import { RulebookPage } from "@/components/RulebookPage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { currentRules } from "@/data/rules";
import { DescriptionBlocks } from "./DescriptionBlocks";

export function FestiveGames() {
  return (
    <RulebookPage title="Festival Games">
      <p className="text-sm text-muted-foreground mb-3">
        The Challenge of 13 is host to many smaller contests, where Warlocks can
        show off their skill to one another and vie for tempting prizes.
      </p>

      {currentRules.festiveGames.map((game) => (
        <Card key={game.id} className="mb-3">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">{game.name}</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground space-y-3">
            <DescriptionBlocks blocks={game.description} />

            <div>
              <p className="font-semibold text-foreground mb-1">Scoring</p>
              <ul className="list-disc list-inside space-y-1">
                {game.scoring.map((criterion, i) => (
                  <li key={i}>{criterion}</li>
                ))}
              </ul>
            </div>

            <div>
              <p className="font-semibold text-foreground mb-1">🏆 Prizes</p>
              <ul className="list-disc list-inside space-y-1">
                {game.prize.map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            </div>
          </CardContent>
        </Card>
      ))}
    </RulebookPage>
  );
}
